module.exports = __webpack_public_path__ + "static/media/Singaling.10ecb8c4.png";